module.exports = __webpack_public_path__ + "static/render_night_2K_sig-41916936c7f02268fb4bb56b38ae1577.jpg";